import React from "react"
import { useTranslation } from 'react-i18next'
import "./legalPage.scss"

const LegalPage = () => {
  const { t } = useTranslation('common')

  return (
    <section className='legalPage'>
      <div className='container'>
        <div className='heading'>
          <h1>{t('Legal Mentions & Privacy Policy')}</h1>
          <p>{t('Last updated: January 2026')}</p>
        </div>

        <div className='contentBox'>
          <h2>1. {t('Publisher Information')}</h2>
          <p>
            {t('This website is the official platform for Château Le Corvier, managed by')} <strong>AuCoeur Service</strong>.
          </p>
          <ul>
            <li><strong>{t('Company')}:</strong> AuCoeur Service</li>
            <li><strong>{t('Headquarters')}:</strong> 49 BOULEVARD BESSIERES 75017 PARIS</li>
            <li><strong>{t('Registration')}:</strong> 911 848 083 R.C.S. Paris</li>
            <li><strong>{t('Director of Publication')}:</strong> Quoc Thai NGUYEN CAO, Minh Ngoc Hoa ROUDAUT</li>
          </ul>

          <h2>2. {t('Short-Term Rental Service')}</h2>
          <p>
            {t('Château Le Corvier is offered for short-term rental in its entirety. This website serves as a platform for information and reservation demands. We do not process direct payments on this site; all demands are subject to manual confirmation.')}
          </p>

          <h2>3. {t('Data Collection (RGPD)')}</h2>
          <p>
            {t('To process your reservation demands and send you relevant information, we collect the following personal data:')}
          </p>
          <ul>
            <li>{t('Full Name')}</li>
            <li>{t('Email Address')}</li>
            <li>{t('Mobile Phone Number')}</li>
          </ul>
          <p>
            {t('This data is strictly used by AuCoeur Service to contact you via phone or email to confirm availability, prices, and finalize your booking. We do not sell your data to third parties.')}
          </p>

          <h2>4. {t('Cookies')}</h2>
          <p>
            {t('This site does not contain any cookies.')}
          </p>

          <h2>5. {t('Contact')}</h2>
          <p>
            {t('For any request regarding your personal data (access, modification, or deletion), please contact us at:')} 
            <br />
            <strong>roudautaulac@gmail.com, contact@cosynest-re.fr, aucoeur.contact@gmail.com</strong>
          </p>
        </div>
      </div>
    </section>
  )
}

export default LegalPage
